if (typeof UseSwStat == 'undefined' || typeof UseSwStat == 'null') {
    var UseSwStat = false;
}



if (typeof UseTagManager == 'undefined' || typeof UseTagManager == 'null') {
    UseTagManager = false;
}

//function setContentHeight() {
//    if ($(window).width() < 768) {
//        $(".BasketCenterContent").height(300);
//        $(".BasketCenterContent").css("max-height", 300);
//    } else {
//        $(".BasketCenterContent").height(300);
//        $(".BasketCenterContent").css("max-height", 300);
//    }


//$(window).resize(function () {
//    if ($(window).width() < 768) {
//        $(".BasketCenterContent").height(300);
//        $(".BasketCenterContent").css("max-height", 300);
//    } else {
//        var ContentHeight = $(".SepetProducts").height() - 360;
//        $(".BasketCenterContent").height(300);
//        $(".BasketCenterContent").css("max-height", 300);
//    }

//});

//}

//function toggleBasket() {


//    if ($(".SepetProducts").is(":visible")) {
//        $(".SepetProducts").stop().animate({ "left": "100%" }, 200, function () {
//            $(".SepetProducts").stop().hide();
//            $("body").removeClass("BasketDropped");
//        });
//    } else {
//        $(".SepetProducts").stop().animate({ "left": "56%" }, 200, function () {
//            $(".SepetProducts").stop().show();
//            setContentHeight();
//            $("body").addClass("BasketDropped");
//        });
//    }

//}


function BlockMobileBasketClick(){

    $(".SepetButton > a").on("click", function (e) {
        if($(window).width() < 992){
            e.preventDefault();
            return false;
        }
    });

}

function TagAutoComplate() {


    if ($(".SearchModal").length > 0) {

        $(".SearchModal input:first").autocomplete({

            source: "/" + $("#SmallLangCode").val() + "/p/Cat/CompleteNames",
            minLength: 2,
            select: function (event, ui) {



                if (ui.item.FilterType == "Product") {
                    window.location.href = "/" + $("#SmallLangCode").val() + "/" + ui.item.HexValue;
                }

                if (ui.item.FilterType == "Tag" || ui.item.FilterType == "Color") {
                    window.location.href = "/" + $("#SmallLangCode").val() + "/p/Cat/NewSearch?sr=" + ui.item.MainValue;
                }


                if (ui.item.FilterType == "BlogPost") {
                    window.location.href = "/blog" + ui.item.SubValue;
                }

                //$(".SearchModal input:first").val(ui.item.value);
                //$(".SearchModal form").submit();

            }
            ,
            create: function () {


                $(this).data('ui-autocomplete')._renderItem = function (ul, item) {


                    if (item.FilterType == "Product") {
                        $li = $('<li class="PrItem">').append('<img src="' + item.ImagePath + '" alt="" />');

                        $li.append("<span class='PrHeader'>" + item.SubValue + "</span>");
                        $li.append("<span>" + item.MainValue + "</span>");
                        $li.append("<span class='Info'></span>");

                        $li.appendTo(ul);

                        return $li;

                    }
                    if (item.FilterType == "BlogPost") {

                        $li = $('<li class="BlogItem">').append('<img src="' + item.ImagePath + '" alt="" />');

                        $li.append("<span class='BlogHeader'>" + item.MainValue + "</span>");
                        $li.append("<span>" + item.HexValue + "</span>");
                        $li.append("<span class='Info'></span>");

                        $li.appendTo(ul);

                        return $li;

                    }
                    else
                        if (item.FilterType == "Color") {
                            $li = $('<li class="ColorItem">').append('<span class="HexItem" style="background-color:#' + item.HexValue + '" alt="" />');

                            $li.append("<div class='ColorHeader'>" + item.MainValue + "</span><span>Renklerde Arayın</span>");
                            $li.append("");
                            $li.append("<span class='Info'></span>");

                            $li.appendTo(ul);

                            return $li;

                        } else if (item.FilterType == "Tag") {

                            return $('<li class="TagItem">')
                                    .append('<a href="' + "/" + $("#SmallLangCode").val() + "/Tags/" + item.SubValue + '">' + item.MainValue + '</a>')
                                    .append("<span class='Info'></span>")
                                    .appendTo(ul);
                        }
                        else {


                            return $('<li>')
                        .append(item.MainValue)
                        .appendTo(ul);
                        }

                };
            },
            focus: function (event, ui) {

                event.preventDefault();
                $(".SearchModal form input:first").val(ui.item.MainValue);

            }

        });
    }
}

function GetHelp(x) {

    $('.help_div').hide();
    $('.help_' + x).show();


    $('.help_' + x).children("div.subhelp:first").show();


}

function changeSiteLanguage(langID, langCode) {

    var url = "/";
    var Catalogs = $("#PgCatalogs").val().split("/");
    var ctlgs = "";

    for (var i = 0 ; i < Catalogs.length; i++) {
        if (Catalogs[i].length > 0) {
            ctlgs += "&Cats=" + Catalogs[i];
        }
    }

    $.ajax({
        type: 'get',
        url: '/Home/ChangePageLang',
        data: 'PID=' + $("#PID").val() + "&PgType=" + $("#PgType").val() + "&AName=" + $("#AName").val() + "&CName=" + $("#CName").val() + "&langID=" + langID + ctlgs + "&langCode=" + langCode,
        success: function (dt) {
            window.parent.location.href = dt;
        }
    });

}

function changeSiteTheme(layout) {

    //var hs = window.location.hash;
    //hs = hs.replace("=", "[_]");
    //hs = hs.replace("&", "[and]")

    $.ajax({
        type: 'get',
        url: '/Home/ChangeTheme',
        data: 'Url=' + window.location.pathname + "&th=" + layout + "&hash=" + window.location.hash,
        success: function (dt) {

            window.parent.location.href = dt;
        }
    });

}

function ShowLangAreaForChange() {


    var userLang = navigator.language || navigator.userLanguage;

    if (userLang != null && userLang != undefined && userLang.length > 2) {

        userLang = userLang.substr(0, 2).toLowerCase();
    }

    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/Home/ShowLangSwitch",
        success: function (data) {

            if ($(".LangSelectionArea").length <= 0) {

                if (document.URL.indexOf("localhost") >= 0) {

                    $(".FixedHeader > .container:first").prepend(data);
                }

            } else if ($(".LangSelectionArea").hasClass("gizle")) {

                if (document.URL.indexOf("localhost") >= 0) {

                    $(".LangSelectionArea").show();
                }

            } else {

                $(".LangSelectionArea").hide();
            }

        }
    });

}

function ShowCurrencyForChange() {


    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/Home/ShowCurrencySwitch",
        success: function (data) {

            if ($(".CurrrencySelectionArea").length <= 0) {

                if ($(".AllowCurrencyChange").length > 0) {

                    $(".FixedHeader > .container:first").prepend(data);
                }

            } else if ($(".CurrrencySelectionArea").hasClass("gizle")) {

                if ($(".AllowCurrencyChange").length > 0) {

                    $(".CurrencySelectionArea").show();
                }


            } else {

                $(".CurrrencySelectionArea").hide();
            }

        }
    });

}

function SetWindowSize() {

    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/User/SetUserWindowSize?u.Width=" + $(window).width() + "&u.Height=" + $(window).height(),
        cache: false,
        success: function (cdt) {

        }
    });

    if ($(window).width < 980) {

        $("#LoginRegisterModal .modal-content").css("background-image", "none");
        $("#LoginRegisterModal .modal-content").removeAttr("style");

    }

}


var mouse_is_inside_search = false;
var mouse_is_inside_userandBasket = false;
var mouse_is_inside_LeftMenu = false;
var mouse_is_inside_MainMenu = false;


function RemoveProductInformationToDataLayer(id, name, category, brand, variant, price, quantity) {
    ga('ec:addProduct', {
        'id': id,
        'name': name,
        'category': category,
        'brand': brand,
        'variant': variant,
        'price': price,
        'quantity': quantity
    });

    ga('ec:setAction', 'remove');
    ga('send', 'event', 'UX', 'click', 'remove from cart');     // Send data using an event.
}

function HideOpenWindows() {

    if (!mouse_is_inside_search) {

        $(".SearchModal").hide();

    }

    if (!mouse_is_inside_userandBasket) {

        $(".RightBasket").removeClass("active");
        $(".RightAccount ").removeClass("active");
        $("ul#MainMenu.Monitor > li").removeClass("open");

    }

    if (!mouse_is_inside_search && !mouse_is_inside_userandBasket && !mouse_is_inside_LeftMenu) {

        //$("body").removeClass("BackDropped");
    }

    if (!mouse_is_inside_MainMenu) {
        $("ul#MainMenu.Monitor > li").removeClass("open");
    }

}

$('.SearchModal form, .RightSearch').live({
    mouseenter:
        function () {
            mouse_is_inside_search = true;
        },
    mouseleave:
       function () {
           mouse_is_inside_search = false;
       }
});

$('.SubMenuContainer, #MainMenu').live({
    mouseenter:
       function () {
           mouse_is_inside_MainMenu = true;
           $(".FilterOption .slider").hide();
       },
    mouseleave:
       function () {
           mouse_is_inside_MainMenu = false;
           $(".FilterOption .slider").show();
       }
});


$.fn.exists = function () {
    return this.length !== 0;
}

var lastpos = -1;
var showTopLink = 100;
var width = 0;
var UserValue;

//function NewsletterPopupControl() {
//    if ($.cookie('NewsletterPopup') != "undefined" && $.cookie('NewsletterPopup') != "false") {
//        $.ajax({
//            type: 'get',
//            async: true,
//            cache: false,
//            url: "/" + $("#SmallLangCode").val() + "/p/User/UserCheck",
//            success: function (dt) {
//                console.log(dt);
//                if (dt.USER == -1 && $("#SmallLangCode").val() == "tr") {s
//                    $("#NewsletterPopup").modal();
//                }
//            }
//        });

//    }


$('#NewsletterPopup').on('hidden.bs.modal', function () {
    var expireDate = new Date();
    var minutes = 30;
    expireDate.setTime(expireDate.getTime() + (minutes * 60 * 1000) * 6);

    $.cookie('NewsletterPopup', false, { expires: expireDate, path: '/' });
    $(".NewsLetterResult").hide();
    $(".NewsletterFormHead").show();
})


//    $("#IgnoreLink > a,.DialogClose").live("click", function () {

//        var expireDate = new Date();
//        var minutes = 30;
//        expireDate.setTime(expireDate.getTime() + (minutes * 60 * 1000) * 6);
//        //alert(expireDate);
//        $.cookie('NewsletterPopup', false, { expires: expireDate, path: '/' });
//        $("#NewsletterPopup").modal("hide");

//    });


//    $("#newsletterFormSubmit").live("click", function () {
//        var expireDate = new Date();
//        var minutes = 30;
//        expireDate.setTime(expireDate.getTime() + (minutes * 60 * 1000) * 6);
//        //alert(expireDate);
//        $.cookie('NewsletterPopup', false, { expires: expireDate, path: '/' });
//    });

//}

function AddToBasket() {
    $(".ProductList .Prd .AddToCart").on("click", function (e) {


        var SizeID = $(this).attr("data-sizeid");
        var SizeDropID = "1";
        var ColorID = $(this).attr("data-colorid");
        var ProductID = $(this).attr("data-productid");

        var Amount = 1;
        var LangID = $("#LangID").val();
        var UrunYok = $('#UrunYok').val();


        SizeDropID = "1";

        $basketButton = $(this);

        if (SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != "") {
            
            var SizeDrop = "";

            var NormalText = $basketButton.text();
            var AddingText = $basketButton.attr("data-adding");
            $basketButton.text(AddingText);

            if (SizeDropID == "yok") {
                SizeDrop = "";
            }
            else {
                SizeDrop = "&SizeDropID=" + SizeDropID;

            }

            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToCart",
                data: 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + Amount + "&langID=" + LangID + SizeDrop,
                dataType: 'json',
                async: true,
                success: function (dt) {
                    if ($(window).width() < 768) {
                        $basketButton.html("<div class='BasketIcon hidden-md hidden-lg'></div>" + NormalText);
                    }
                    else {
                        $basketButton.text(NormalText);
                    }

                    //alert(dt.Sonuc + dt.IslemSonucAciklama);
                    $("#GeneralModal .modal-header h3").html(dt.IslemSonucAciklama);

                    if (dt.Sonuc == true) {

                        $Modal = $("div#QuickLookModal");

                        if ($Modal.length > 0) {
                            $Modal.modal("hide");
                        }

                        $.ajax({
                            type: 'get',
                            url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
                            data: "",
                            async: true,
                            contentType: "application/json; charset=utf-8",
                            dataType: 'text',
                            success: function (dt) {

                                $("#UserAndBasket").html(dt);

                                $('html, body').animate({ scrollTop: 0 }, 'slow');

                                $(".RightBasket").addClass("active");
                                $("body").addClass("BackDropped");

                                $(".SepetProducts").hide();
                                $(".SepetProducts").addClass("activeBasket");
                                //setBasketContainerHeight();
                                $(".AjaxLoaderDiv").hide();

                            }
                        });


                        if (typeof UseSwStat != 'undefined' && UseSwStat == true) {

                            var basketParams = GetSwPageParams();

                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ActionType", "SepeteEkleme");
                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ProductID", ProductID);
                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ColorID", ColorID);
                            basketParams += "&CatalogID=" + $("#CurCatalogID").val();

                            AddSwAction(basketParams);

                        }

                        if (UseTagManager) {

                            SendCartAddEvent('');
                        }


                    }
                    else {

                        alert(dt.IslemSonucAciklama);
                    }


                }
            });




        }
        else {

            if (SizeID == undefined || SizeID == "") {


                $("#PrdBlackBg").show();
                $(".SizeOptions.open").addClass("PleaseSelect");
                // $("body").addClass("BackDropped");

                $('html, body').animate({
                    scrollTop: $(".SizeOptions").offset().top - 150
                }, 500);


                if ($(".AutoTextRep").length > 0) {

                    $(".AddToBasket button").attr("data-first", $(".AddToBasket button").text());
                    $(".AddToBasket button").text($('#BedenSec').val());

                    $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }

            }

            if (ColorID == undefined || ColorID == "") {

                alert(RenkSec);

                $(".AddToBasket button").attr("data-first", $(".AddToBasket button").text());
                $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());

                if ($(".AutoTextRep").length > 0) {
                    $(".AddToBasket button").text($('#BedenSec').val());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }

            }

            if (ProductID == undefined || ProductID == "") alert(UrunYok);


        }

        e.preventDefault();
        return false;

    });
}



function LoginIcon() {
    $(".LoginIcon").on("click", function () {
        $("#RegisterLoginModal").modal();
    });
}

function MenuMouseOver() {
    $("#MainMenu > ul > li").on("mouseover", function () {
        $("body").addClass("BackDropped");
    });
}


function BasketMouseOver() {
    $(".RightBasket").on("mouseover", function () {
        $("body").addClass("BackDropped");
    });
    $(".RightBasket").on("mouseout", function () {
        $("body").removeClass("BackDropped");
    });

}


function RegisterLoginModal() {

    $(".RightAccount #AccountLink").live("click", function () {
        if ($("#AccountMenu").length <= 0) {
            $("#RegisterLoginModal").modal("toggle");
        }
    });

    $(".card-define-button").live("click", function () {

        $("div.RegisterRow").hide();
        $("div.LoginRow").hide();
        $("div.HappyShopControl").show();
        $("span.ControlResult").hide();
        $("div#AlertResult").hide();

    });

    $(".create-user-button").live("click", function () {

        if ($(".leftColumn > h2 > span.selected").html() == "Giriş Yap") {

            $("div.RegisterRow").hide();
            $("div.LoginRow").show();
            $("div.HappyShopControl").hide();
            $("span.ControlResult").hide();
        }

        else if ($(".leftColumn > h2 > span.selected").html() == "Yeni Üyelik") {

            $("div.RegisterRow").show();
            $("div.LoginRow").hide();
            $("div.HappyShopControl").hide();
            $("span.ControlResult").hide();
        }

        $(".create-user-button > span").each(function () {
            if ($(this).hasClass("selected")) {
                $(this).removeClass("selected");
            }
            else {
                $(this).addClass("selected");
            }
        });

        $(".leftColumn > h2 > span").each(function () {
            if ($(this).hasClass("selected")) {
                $(this).removeClass("selected");
            }
            else {
                $(this).addClass("selected");
            }
        });

        if ($(window).width() < 768) {
            $('#RegisterLoginModal').animate({ scrollTop: 0 }, 'slow');
        }

        //$(".UyeKayitCol > div").each(function () {
        //    if ($(this).hasClass("selected")) {
        //        $(this).removeClass("selected");
        //    }
        //    else {
        //        $(this).addClass("selected");
        //    }
        //});



    });


    $(".modal-close-button").live("click", function () {
        $("#RegisterLoginModal").modal("toggle");
    });


    $('#RegisterLoginModal').on('show.bs.modal', function () {
        $(".UyeKayitCol > div").removeClass("selected");
        $(".UyeKayitCol .LoginRow").addClass("selected");
        $(".create-user-button span").removeClass("selected");
        $(".create-user-button .createUser").addClass("selected");
        $("header").addClass("LoginModal");
        $("#AlertResult").hide();
    });




    $('#RegisterLoginModal').on('hidden.bs.modal', function () {

        $("header").removeClass("LoginModal");
        $("#AlertResult").hide();

    });

}

function MenuBannerSettings() {
    $DefaultImage = "";

    $(".ListWrapper > ul > li").hover(function () {
        $BannerArea = $(this).parent().parent().parent().find(".MenuBanner > img");
        $DefaultImage = $BannerArea.attr("src");

        if ($(this).data("img") != "" && $(this).data("img") != null) {
            $BannerArea.attr("src", $(this).data("img"));

        }
    }, function () {
        $BannerArea.attr("src", $DefaultImage);
    });

}

function Isfollow() {

    var ProductID = $("#ProductID").val();
    $That = $(".AddToFavorite");

    if (ProductID != undefined) {
        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/IsFollow",
            data: 'ProductID=' + ProductID,
            dataType: 'json',
            async: true,
            success: function (dt) {
                if (dt.IsFollow == true) {
                    $That.removeClass("passiveFavorite");
                    $That.addClass("activeFavorite");
                } else {
                    $That.addClass("passiveFavorite");
                    $That.removeClass("activeFavorite");
                }



            }
        });
    }

}

function AutoDropSelection() {
    $(".DropItems a:first-child").trigger("click");
}


function GetHappyShopCardPrice() {

    var Amount = $("#ForMemberCardAmount").val();
    var OldAmount = $("#ForMemberCardOldAmount").val();
    var MemberCardGroupID = $("#MemberCardGroupID").val();
    var ForMemberCardCurrencyCode = $("#ForMemberCardCurrencyCode").val();

    if (Amount != undefined && OldAmount != undefined && MemberCardGroupID != undefined && ForMemberCardCurrencyCode != undefined && MemberCardGroupID != -1) {
        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetMemberCardPrice",
            data: 'Amount=' + Amount + "&AmountOld=" + OldAmount + "&MemberCardGroupID=" + MemberCardGroupID,
            dataType: 'json',
            async: true,
            success: function (dt) {
                if (dt.TotalAmount != "0" && dt.TotalAmount != 0) {
                    $(".RPrice").html(dt.TotalAmount + " " + ForMemberCardCurrencyCode);
                    $(".HappyShopCardPrice").css("display", "inline-block");
                }

            }
        });
    }

}
function MobileMenuSetting() {

    $("#MainMenu > ul > li").each(function () {
        if ($(this).find(".itemsWrapper").length > 0 && !$(this).hasClass("TabletMenu")) {
            $(this).addClass("plus-icon");
        }
    });

    //$("#MainMenu > ul > li > .itemsWrapper > .ListWrapper > ul > li").each(function () {
    //    if ($(this).find("#MainMenu > ul > li > .itemsWrapper > .ListWrapper > ul > li > div").length > 0 && !$('#MainMenu > ul > li').hasClass("TabletMenu")) {
    //        $(this).addClass("plus-icon");
    //    }
    //});

}

function AddToFavorite() {


    $(".passiveFavorite").live("click", function () {
        var ColorID = $("#ColorID").val();
        var ProductID = $("#ProductID").val();
        $That = $(this);
        if (ColorID != undefined && ProductID != undefined) {
            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToFollowList",
                data: 'colorID=' + ColorID + "&productID=" + ProductID,
                dataType: 'json',
                async: true,
                success: function (dt) {
                    if (dt.Sonuc == true) {
                        $That.addClass("activeFavorite");
                        $That.removeClass("passiveFavorite");
                    }


                }
            });
        }
    });


}

function removeFavorite() {
    $(".activeFavorite").live("click", function () {
        var ProductID = $("#ProductID").val();
        $That = $(this);
        if (ProductID != undefined) {
            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/RemoveFromList",
                data: 'id=' + ProductID + "&IsDetail=true",
                dataType: 'json',
                async: true,
                success: function (dt) {
                    if (dt.Sonuc == true) {
                        $That.addClass("passiveFavorite");
                        $That.removeClass("activeFavorite");
                    }


                }
            });
        }
    });
}

function ModalOpenRM() {
    $(".AccountOpen #CardLink").live("click", function () {

        $("#RegisterLoginModal").modal("toggle");

    });
}

function ChangePlaceholderSearch() {

    if ($(window).width() <= 500) {

        $('.fullSearch input[type="search"]').attr("placeholder", "Aradığınız ürün burada.");
    } else {

        $('.fullSearch input[type="search"]').attr("placeholder", "Aramak istediğiniz kelimeyi giriniz.");
    }
}

$(window).resize(ChangePlaceholderSearch).trigger('resize');


$(document).ready(function () {


    RegisterLoginModal();
    ModalOpenRM();
    ChangePlaceholderSearch();
    AddToBasket();
    BlockMobileBasketClick();
 
    $("#HappyShopControlButton").live("click", function () {
        $.ajax({

            type: "POST",
            url: "/tr/p/User/HappyShopCardControl?NameSurname=" + $("#NameSurname").val() + "&PhoneNumber=" + $("#Phone").val() + "&Email=" + $("#Email").val(),
            cache: false,
            success: function (data) {


                if (data > 0) {

                    $("div.HappyShopCardPlace").hide();
                    $("span.ControlResult").css("display", "block");
                    $("span.ControlResult").html('<br/><div class="alert alert-danger">HappyShopCard sahibisiniz. Üye girişi yaparak avantajlardan yararlanabilirsiniz</div>');
                    $("div.LoginRow").css("display", "block");
                }
                else if (data == -1) {
                    $("span.ControlResult").show().html('<br/><div class="alert alert-danger">Lütfen tüm alanları eksiksiz doldurunuz.</div>');

                }
                else if (data.StatusCode == -2) {

                    $("div.HappyShopCardPlace").hide();
                    $("div.RegisterRow").show();
                    $("form.UyeOlModal #LoginNameSurname").val(data.Name);
                    $("form.UyeOlModal #LoginEposta").val(data.Email);
                    $("form.UyeOlModal #UserGsm").val(data.Mobile);
                    $("form.UyeOlModal #LoginPassword").val("");

                    $("span.ControlResult").show().html('<div class="alert alert-danger">HappyShopCard tanımlamak için önce üye olunmalıdır.</div>');
                }
                else {

                    $("div.HappyShopCardPlace").hide();
                    $("span.ControlResult").show().html('<br/><br/><br/><div class="alert alert-danger"> <strong>HappyShopCard</strong> bilginiz bulunmamaktadır, HappyShopCard alarak fırsatlardan yararlanabilirsiniz</div>');

                    setTimeout(function () {
                        window.location.href = "/Home/Index";
                    }, 3000);

                }
            }
        });

        return false;
    });




    //$("#HappyShopControlButton").live("click", function () {
    //    var NameSurname = $("#NameSurname").val();
    //    var PhoneNumber = $("#PhoneNumber").val();
    //    var Email = $("#Email").val();

    //    alert("sdfsfd");

    //    //console.log("geldi");
    //    if (NameSurname != undefined && PhoneNumber != undefined && Email != undefined) {
    //        $.ajax({
    //            type: 'get',
    //            url: "/" + $("#SmallLangCode").val() + "/p/User/HappyShopCardControl",
    //            data: 'NameSurname=' + NameSurname + "&PhoneNumber=" + PhoneNumber + "&Email=" + Email,
    //            dataType: 'json',
    //            async: true,
    //            cache:false,
    //            success: function (dt) {
    //                //if (dt.Sonuc == true) {

    //                    //$("div.HappyShopControl").hide();
    //                    $("span.ControlResult").html("<h3>Sistemde kaydınız bulunmaktadır.");
    //                //}


    //            }
    //        });
    //    }
    //});



    $('.FooterTextShowMore').on('click', function (e, index) {

        $(this).hide();
        $('.FooterTextShowLess').show();
        $('.FooterTextSecondPart').show();
    });

    if (document.URL.indexOf("/outlet") != -1 && $("#MainMenu .outlet").length > 0) {
        $("#MainMenu .outlet").show();
        $("#MainMenu .outlet").prev().hide();
    }

    $('.FooterTextShowLess').on('click', function (e, index) {

        $(this).hide();
        $('.FooterTextShowMore').show();
        $('.FooterTextSecondPart').hide();

    });

    //$(".SepetProducts .closeImage").live("click", function () {
    //    toggleBasket();
    //    $(".SepetProducts").removeClass("activeBasket");
    //    $("body").removeClass("BasketDropped");
    //    $("body").removeClass("BackDropped");
    //});


    $("#MainMenu > ul > li").on("click", function () {
        if ($(window).width() < 992 && !$(this).hasClass("TabletMenu") && !$(this).find(".itemsWrapper").length <= 0) {
            //console.log("aaa");
            //$(this).find('nav .ListWrapper ul li div').css("display", "block");

            $(this).find(".itemsWrapper").slideToggle();
           
            $(this).toggleClass("minus-icon");
            
        }
    });


    MobileMenuSetting();
    MenuBannerSettings()
    //NewsletterPopupControl();
    AddToFavorite();
    removeFavorite();

    if ($(window).width < 980) {
        $("#LoginRegisterModal .modal-content").css("background-image", "none");
        $("#LoginRegisterModal .modal-content").removeAttr("style");
    }

    $('.top_link').hide();
    width = $(window).width();

    $('.OpenLeftMenu').hover(function () {
        mouse_is_inside_LeftMenu = true;
    }, function () {
        mouse_is_inside_LeftMenu = false;
    });

    $('.UserAndBasket, .BasketContainer').live({
        mouseenter:
        function () {

            mouse_is_inside_userandBasket = true;

        },
        mouseleave:
           function () {
               mouse_is_inside_userandBasket = false;
           }
    });


    var ThemePath = "/Images/BlackTheme/";

    if ($(".LogoContainer img").length > 0) {
        ThemePath = $(".LogoContainer img:first").attr("src").replace("Logo.png", "");
    }

    //Menu 
    if ($("ul#MainMenu").length > 0) {

        //$("ul#MainMenu").ResponsiveMenu();

    }

    // alert("ismobile:" + isMobile(true) + " IsChrome:" + IsChrome() + " IsFirefox:" + IsFirefox() + "IsSafari:" + IsSafari() + " agent:" + navigator.userAgent.toLowerCase() );

    //if (isMobile(true) && (IsChrome() || IsFirefox() || IsSafari())) {
    //    $("#MainMenu").css("display", "block");
    //}

  
    $('.carousel').carousel();

   
    //$("#MainMenu.Monitor > li:has('.BWOSubMenuShow'), .RightBasket, .RightAccount").live({
    $(".RightAccount").live({ 
        mouseenter:
           function () {

               if (!isMobile(true) && $(this).find("#AccountMenu").length > 0) {
                   $("body").addClass("BackDropped");
               }

           },
        mouseleave:
           function () {


               if (!isMobile(true) && $(".SearchModal").css("display") != "block") {
                   $("body").removeClass("BackDropped");
                   $(".SepetProducts").removeClass("activeBasket");
                   $("ul#MainMenu.Monitor > li").removeClass("open");
               }


           }

    });

    $("#MainMenu > ul > li").live({

        mouseenter:
           function () {

               if (!isMobile(true) && $(this).find(".itemsWrapper").length > 0 && !$("#RegisterLoginModal").is(":visible")) {
                   $("body").addClass("BackDropped");
               }

           },
        mouseleave:
           function () {


               if (!isMobile(true) && $(".SearchModal").css("display") != "block") {
                   $("body").removeClass("BackDropped");
                   $(".SepetProducts").removeClass("activeBasket");
                   $("ul#MainMenu.Monitor > li").removeClass("open");
               }


           }

    });


    //$("body.BackDropped:not(.OpenLeftMenu)").live("click", function () {

    //    HideOpenWindows();

    //});


    //$("body.BackDropped:not(.SepetProducts)").live("click", function () {

    //    if ($(".RightBasket.active").length > 0) {
    //        $(".RightBasket").removeClass("active");
    //    }

    //    if ($(".RightBasket.active").length > 0) {
    //        $(".RightBasket").removeClass("active");
    //    }

    //});



    //$("body .backdrop").on("click", function (e) {

    //    HideOpenWindows();

    //    $("body").removeClass("LeftMenuOpen BackDropped");
    //    $("#MainMenu").removeClass("open");

    //    $("body").removeClass("BasketDropped");
    //    hideBasket();
    //    $(".RightBasket, .RightAccount").removeClass("active");
    //    $(".SepetProducts").removeClass("activeBasket");

    //});

    //$("body").on("click", function (e) {

    //    if (!mouse_is_inside_userandBasket) {
    //        $(".RightBasket.active").removeClass("active");
    //    }


    //});

    $("body .backdrop").on("click", function (e) {

        HideOpenWindows();

        $("body").removeClass("LeftMenuOpen BackDropped");
        $("#MainMenu").removeClass("open");
        //$(".SearchModal").hide();
        $(".RightBasket, .RightAccount").removeClass("active");
        $(".SepetProducts").removeClass("activeBasket");

    });

    $("body").on("click", function (e) {

        if (!mouse_is_inside_userandBasket) {
            $(".RightBasket.active").removeClass("active");
        }


    });

    $("body #PrdBlackBg").on("click", function (e) {

        $("#PrdBlackBg").hide();
        $(".SizeOptions.open").removeClass("PleaseSelect");
        $(".DropItems.PleaseSelect").removeClass("PleaseSelect");
        $(".AddToBasket.PleaseSelect").removeClass("PleaseSelect");
        if ($(".AutoTextRep").length > 0) {
            $(".AutoTextRep button").text($(".AutoTextRep button").attr("data-first"));
        }
    });

    $('.top_link').click(function () {

        $('html, body').animate({ scrollTop: 0 }, 'slow');

    });

    $(window).scroll(function () {

        if ($(window).width() > 767) {
            if ($('.top_link').length > 0) {

                if ($(window).scrollTop() > showTopLink) {
                    $('.top_link').fadeIn('slow');
                } else {
                    $('.top_link').fadeOut('slow');
                }

            }
        }

        if ($(window).scrollTop() > showTopLink) {

            $("body").addClass("Scrolled");

        } else {
            $("body").removeClass("Scrolled");

        }


    });


    var rtime;
    var timeout = false;
    var delta = 500;

    $(window).resize(function () {

        rtime = new Date();
        if (timeout === false) {
            timeout = true;
            setTimeout(resizeend, delta);
        }
    });

    function resizeend() {
        if (new Date() - rtime < delta) {
            setTimeout(resizeend, delta);
        } else {
            timeout = false;

            SetWindowSize();

        }
    }

    $('.bottomMenu p').click(function () {

        $(this).parent().toggleClass("open");

    });

    $("#CurrencySelectionDr").on("click", ".CurrencyItem", function () {

        var hs = window.location.hash;
        hs = hs.replace("=", "[_]");
        hs = hs.replace("&", "[and]")
        var CurrencyID = $(this).attr("data-id");

        $(".CurrenctCur img").attr("src", $(this).find("img").attr("src"));
        $(".CurrenctCur .TL").html($(this).find(".TL").html());
        $(".CurrenctCur .CurrCode").html($(this).find(".CurrCode").html());

        $.ajax({
            type: 'get',
            url: '/Home/ChangeCurrency',
            data: 'Url=' + window.location.pathname + "&currencyID=" + CurrencyID + "&hash=" + window.location.hash,
            success: function (dt) {

                window.location.reload(true);

            }
        });


    });

    $(".CloseModal").on("click", function () {
        $(this).parents(".modal").modal('hide');
    });

    $(".CloseModal").on("click", function () {
        $(this).parents(".modal").modal('hide');
    });


    $(".btn-back").live("click", function () {

        $(this).closest("form").slideUp();

    });

    TagAutoComplate();

    $('body').on('hidden.bs.modal', '.modal', function () {
        $(this).removeData('bs.modal');
    });

    //$('.help_Uyelik, .help_Uyelik .subhelp').hide();
    $('.help_Uyelik, .help_Uyelik .subhelp:first').show();
    $('#helpMenu ul li:first a').addClass("secili");

    //if ($('.helpmenu li a').length > 0) {

    //Help Menu

    $('#helpMenu ul li a').on('click', function (e, index) {

        $('#helpMenu ul li a').removeClass('secili');
        $(this).addClass('secili');
        GetHelp($(this).attr('href').replace(/#/ig, ""));
    });

    $('.subhelptitle').on('click', function (e, index) {


        var c = $(this).attr('id').replace(/title/, "");
        $('.subhelp:visible').slideUp('fast');
        $('.' + c).slideDown('fast');

    });

    $("#HelpNavs div ul").first().show();
    $("#HelpContents ul li").hide();
    $("#HelpContents div").eq($("#HelpNavs div .HelpNavTitles").first().parent().index()).find("ul li:first").show();


    $('#HelpNavs li').click(function () {

        $("#HelpContents ul li").hide();

        $("#HelpContents div").eq($(this).closest("div").index()).find("ul li").eq($(this).index()).show();

    });

    $('#HelpNavs > div').click(function () {


        $("#HelpNavs div > ul").hide();
        $(this).find("ul").show("normal");


    });

    $('.HelpNavTitles').click(function () {

        $("#HelpContents ul li").hide();
        $("#HelpContents div").eq($(this).parent().index()).find("ul li:first").show();

    });

    //$('.close-basket').live('click', function (e) {
    //    $("body").removeClass("BasketDropped");
    //    $("body").removeClass("BackDropped");
    //    toggleBasket();
    //});


    //function hideBasket() {
    //    $(".SepetProducts").stop().animate({ "left": "100%" }, 200, function () {
    //        $(".SepetProducts").stop().hide();
    //        $("body").removeClass("BasketDropped");
    //    });
    //}

    //function showBasket() {

    //    if ($(window).width() > 1199 && $(window).width() > 1510) {
    //        $(".SepetProducts").stop().animate({ "left": "56%" }, 200, function () {
    //            setContentHeight();
    //            $(".SepetProducts").stop().show();
    //            $("body").addClass("BasketDropped");
    //        });
    //    } else {
    //        $(".SepetProducts").stop().animate({ "left": "56%" }, 200, function () {
    //            setContentHeight();
    //            $(".SepetProducts").stop().show();
    //            $("body").addClass("BasketDropped");
    //        });
    //    }


    //}


    $('.RightBasket a').live('click', function (e) {

        e.preventDefault
        //if (isMobile(true)) {

        var isCartActive = $(".RightBasket").hasClass("active");


        $(".RightBasket").addClass("active");

        $(".RightAccount").removeClass("active");
        toggleBasket();


        if (!isCartActive) {
            e.preventDefault;
            return false;
        }

        //}

    });

    //$('.RightAccount').live('click', function (e) {

    //    if (isMobile(true)) {

    //        var isCartActive = $(".RightAccount").hasClass("active");

    //        $("body").addClass("BackDropped");
    //        $(".RightAccount").addClass("active");
    //        $(".RightBasket").removeClass("active");

    //        if (!isCartActive) {
    //            e.preventDefault;
    //            return false;
    //        }

    //    }

    //});




    if ($("#UserAndBasket").length > 0) {

        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
            data: "",
            async: true,
            cache: false,
            contentType: "application/json; charset=utf-8",
            dataType: 'text',
            success: function (dt) {


                $("#UserAndBasket").html(dt);



                if ($("#LangRedirectNeed").length > 0) {

                    //  changeSiteLanguage("0", $("#LangRedirectNeed").val());
                }

                if ($("#LangSelectionNeed").length > 0) {
                    ShowLangAreaForChange();
                }

                if ($("#CheckCampaign").length > 0) {

                    $.ajax({
                        type: "GET",
                        url: "/" + $("#SmallLangCode").val() + "/p/User/CheckForCampaigns",
                        cache: false,
                        success: function (cdt) {

                            if (cdt == "ShowUtm2Banner" && document.URL.indexOf("utm_campaign") < 0) {

                                document.location = "/" + $("#SmallLangCode").val() + "/?utm_campaign=colorselect2";
                            }
                        }
                    });

                }

                BasketMouseOver();

                BlockMobileBasketClick();

                if ($("#WindowSizeNotSetted").length > 0) {

                    SetWindowSize();
                }

                if (UseTagManager) {

                    AddGeneralInfoTagManager('', dtIsLogged, dtUserID);

                    AddProductView('');
                    var promotions = GetPromotionsVariable('');
                    AddImpression('', promotions);
                    //  AddGASliderView('');

                    SendGaDataLayerVirtual();
                }

                var UserID = $("#UserID").val();

                if (UserID != undefined && UserID > 0) {
                    Isfollow();
                }
                GetHappyShopCardPrice();
                AutoDropSelection();
            }
        });

    }

    SetWindowSize();

    //$(".BasketContainer .RemoveIcon").live("click", function () {

    //    var currencyCode = $("#ForMemberCardCurrencyCode").val();
    //    var currentCurrencyCode = "";
    //    if (currencyCode != undefined) {
    //        currentCurrencyCode = currencyCode;
    //    }

    //    var Silid = 0;

    //    if ($(this).attr("data-id") != undefined && $(this).attr("data-id").length > 0) {

    //        Silid = $(this).attr("data-id").replace("sepetsil", "");
    //    }

    //    var gizlenecekSecim = $(this).parent().parent();
    //    var nameOfCurItem = "";
    //    if ($(this).closest(".SepetRow").length > 0) {

    //        gizlenecekSecim = $(this).closest(".SepetRow");
    //        nameOfCurItem = $(gizlenecekSecim).find(".SepetPrdHeader").text();
    //    }
    //    var LangID = $("#LangID").val();

    //    $(gizlenecekSecim).find(".ustSepetAjaxLoader").show();
    //    $(gizlenecekSecim).find(".ustSepetDelete").hide();
    //    $(gizlenecekSecim).css("opacity", "0.5");

    //    dataall = "";

    //    if ($(this).attr("data-all") == "true") {

    //        dataall = "&all=true";
    //        gizlenecekSecim = $(".SepetProducts");
    //    }

    //    if (1 == 1 || $(".ProductDetail").length > 0) {
    //        dataall += "&pd=true";
    //    }

    //    $removedItem = $(gizlenecekSecim).clone();

    //    $.ajax({
    //        type: 'get',
    //        url: '/' + $("#SmallLangCode").val() + '/p/Cart/RemoveFromCart',
    //        data: 'id=' + Silid + "&langID=" + LangID + dataall,
    //        contentType: "application/json; charset=utf-8",
    //        dataType: 'json',
    //        success: function (dt) {

    //            if (dt.Sonuc == true) {


    //                $(gizlenecekSecim).hide("slow");


    //                if ($("span#SepetToplamTutar").length > 0) {

    //                    if ($("span:last", "span#SepetToplamTutar").length > 0) {
    //                        $("span:last", "span#SepetToplamTutar").text(dt.Deger1.toFixed(2));
    //                    }
    //                    console.log("test-1 --> " + $(".SepetToplamTutar:first span.CartTotalAmount span.PriceRound").length);
    //                    if ($(".SepetToplamTutar:first span.CartTotalAmount span.PriceRound").length > 0) {
    //                        $deger = dt.Deger1.toFixed(2).toString();
    //                        var CartTotalAmount = new Array();
    //                        CartTotalAmount = $deger.split('.');
    //                        $(".SepetToplamTutar span").html(CartTotalAmount[0] + "<span class=\"PriceRound\">." + parseInt(CartTotalAmount[1]) + "</span>");
    //                        console.log("test-2");

    //                    }

    //                    else {
    //                        $(".SepetToplamTutar span").html(dt.Deger1.toFixed(2) + " " + currentCurrencyCode);
    //                        $(".HappyShopCartAmount").html(dt.Deger7.toFixed(2) + " " + currentCurrencyCode);

    //                        console.log("test-2" + dt.Deger1.toFixed(2));
    //                    }



    //                    if ($("#FirstCountryID").length > 0) {

    //                        $.fn.AddOrRemoveCargo();

    //                    }
    //                }


    //                $userCartIcon = $(".UserCartIcon");

    //                if ($userCartIcon.length > 0) {

    //                    $BasketIconCountItem = $(".UserCartIcon").find(".IconCount");
    //                    var IconCount = Number($BasketIconCountItem.text());
    //                    IconCount = IconCount - Number($(gizlenecekSecim).attr("data-quantity"));
    //                    $BasketIconCountItem.text(IconCount);
    //                    if (IconCount <= 0) {
    //                        $BasketIconCountItem.addClass("gizli");
    //                    }


    //                    if ($("div.SepetRow:visible").length - 1 <= 0) {
    //                        $userCartIcon.addClass("Blank");
    //                    }

    //                }

    //                $(".RightBasket .BasketItemCount").html(Number(dt.Deger4));
    //                $(".RightBasket .BasketHeader").html("<span>Sepet(" + dt.Deger4 + ")</span>");

    //                if ($("#MainSepetAdet > span.CartTotalItem").length > 0) {

    //                    if ($(".BasketText > span").length > 0) {
    //                        $(".BasketText > span").html(Number(dt.Deger4));
    //                    }
    //                    if ($(".CartAmount > span").length > 0) {
    //                        $(".CartAmount > span").html(Number(dt.Deger4));
    //                    }
    //                }
    //                else {
    //                    if ($(".CartAmount").length > 0) {
    //                        $(".CartAmount").html(Number(dt.Deger4));
    //                    }
    //                }


    //                if (UseTagManager) {

    //                    SendCartRemoveEvent('', $removedItem);
    //                }


    //            }
    //            else {

    //                alert(dt.IslemSonucAciklama);
    //            }

    //        }
    //    });


    //});



    $(".BasketContainer .RemoveIcon").live("click", function () {

        var Silid = 0;

        if ($(this).attr("data-id") != undefined && $(this).attr("data-id").length > 0) {

            Silid = $(this).attr("data-id").replace("sepetsil", "");
        }

        var gizlenecekSecim = $(this).parent().parent();
        var nameOfCurItem = "";
        if ($(this).closest(".SepetRow").length > 0) {

            gizlenecekSecim = $(this).closest(".SepetRow");
            nameOfCurItem = $(gizlenecekSecim).find(".SepetPrdHeader").text();
        }
        var LangID = $("#LangID").val();

        $(gizlenecekSecim).find(".ustSepetAjaxLoader").show();
        $(gizlenecekSecim).find(".ustSepetDelete").hide();
        $(gizlenecekSecim).css("opacity", "0.5");

        dataall = "";

        if ($(this).attr("data-all") == "true") {

            dataall = "&all=true";
            gizlenecekSecim = $(".SepetProducts");
        }

        if (1 == 1 || $(".ProductDetail").length > 0) {
            dataall += "&pd=true";
        }

        $removedItem = $(gizlenecekSecim).clone();

        $.ajax({
            type: 'get',
            url: '/' + $("#SmallLangCode").val() + '/p/Cart/RemoveFromCart',
            data: 'id=' + Silid + "&langID=" + LangID + dataall,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: function (dt) {

                if (dt.Sonuc == true) {


                    RemoveProductInformationToDataLayer
                        (
                        dt.JsonRs.id,
                        dt.JsonRs.name,
                        dt.JsonRs.category,
                        dt.JsonRs.brand,
                        dt.JsonRs.variant,
                        dt.JsonRs.price,
                        dt.JsonRs.quantity
                        );


                    $(gizlenecekSecim).hide("slow");


                    if ($("span#SepetToplamTutar").length > 0) {

                        if ($("span:last", "span#SepetToplamTutar").exists()) {
                            $("span:last", "span#SepetToplamTutar").text(dt.Deger1.toFixed(2));
                        }

                        if ($(".SepetToplamTutar:first span.CartTotalAmount span.PriceRound").length > 0) {
                            $deger = dt.Deger1.toFixed(2).toString();
                            var CartTotalAmount = new Array();
                            CartTotalAmount = $deger.split('.');
                            $(".SepetToplamTutar span.CartTotalAmount").html(CartTotalAmount[0] + "<span class=\"PriceRound\">." + parseInt(CartTotalAmount[1]) + "</span>");


                        }

                        else {
                            $(".SepetToplamTutar:first span:last").html(dt.Deger1.toFixed(2));
                        }



                        if ($("#FirstCountryID").length > 0) {

                            $.fn.AddOrRemoveCargo();

                        }
                    }


                    $userCartIcon = $(".UserCartIcon");

                    if ($userCartIcon.length > 0) {

                        $BasketIconCountItem = $(".UserCartIcon").find(".IconCount");
                        var IconCount = Number($BasketIconCountItem.text());
                        IconCount = IconCount - Number($(gizlenecekSecim).attr("data-quantity"));
                        $BasketIconCountItem.text(IconCount);
                        if (IconCount <= 0) {
                            $BasketIconCountItem.addClass("gizli");
                        }


                        if ($("div.SepetRow:visible").length - 1 <= 0) {
                            $userCartIcon.addClass("Blank");
                        }

                    }

                    $(".RightBasket .BasketItemCount").html(Number(dt.Deger4));

                    if ($("#MainSepetAdet > span.CartTotalItem").length > 0) {

                        if ($(".BasketText > span").length > 0) {
                            $(".BasketText > span").html(Number(dt.Deger4));
                        }
                        if ($(".CartAmount > span").length > 0) {
                            $(".CartAmount > span").html(Number(dt.Deger4));
                        }
                    }
                    else {
                        if ($(".CartAmount").length > 0) {
                            $(".CartAmount").html(Number(dt.Deger4));
                        }
                    }


                    if (UseTagManager) {

                        SendCartRemoveEvent('', $removedItem);
                    }


                }
                else {

                    alert(dt.IslemSonucAciklama);
                }

            }
        });


    });

    if (isMobile(true)) {

        $("#PayNow").live("mouseenter", function (e) {

            document.location.href = $(this).attr("href");

        });
    }

    $('.RightSearch').live('click', function (e) {
        console.info($("body").hasClass("Scrolled"))
        if ($("body").hasClass("Scrolled")) {

            $("body").addClass("Scrolled");
            $("body").addClass("BackDropped");

        }
        else {
            $("body").addClass("BackDropped");
        }


        $(".SearchModal").show();

        $(".SearchModal input:first").focus();
        $('html, body').animate({ scrollTop: 0 }, 'slow');


    });

    $('.headerSearchButton').live('click', function (e) {

        $("body").addClass("BackDropped");
        $(".SearchModal").show();

        $(".SearchModal input:first").focus();
        $('html, body').animate({ scrollTop: 0 }, 'slow');

    });


    $('.OpenLeftMenu, .CloseLeftMenu, .ToggleMMenuIcon , .MainIcon').live('click', function (e) {

        $("#Mainmenu ul li div.itemsWrapper").hide();
        $("#MainMenu").toggleClass("open");
        if ($("#MainMenu").hasClass("open") == true) {

            $('html, body').animate({ scrollTop: 0 }, 'slow');
            $("body").addClass("BackDropped LeftMenuOpen");

        }
        else {

            $("body").removeClass("BackDropped LeftMenuOpen");

        }

    });

    $('.SearchModal form input').keyup(function (event) {

        if (event.keyCode == 27) {

            $("body").removeClass("BackDropped");
            $(".SearchModal").hide();

        }
    });

    $('.CloseSearch').click(function (event) {


        $("body").removeClass("BackDropped");
        $(".SearchModal").hide();

    });

    if ($("#FbConfirmMergeModal").length > 0) {

        $("#FbConfirmMergeModal").modal("show");

    }

    if ($("#FbMergeResultModal").length > 0) {

        $("#FbMergeResultModal").modal("show");

    }


    if (window.location.hash == "#Rg" && isMobile(true)) {


        $('html, body').animate({
            scrollTop: $("#LineRg").offset().top + -80
        }, 500);

    }

    if (window.location.hash != undefined && document.URL.indexOf("Yardim") > 0) {

        var curHash = window.location.hash.replace("#", "");

        $("#helpMenu a[href$='" + curHash + "']").trigger("click");
    }


    if (window.location.hash == "#Lg" && isMobile(true)) {


        $('html, body').animate({
            scrollTop: $(".GeneralBreadCrumb:first").offset().top + -50
        }, 500);


    }


    $(".ForgetPass").on("click", function (e) {

        $("#forgottenpassModal").modal('show');

    });

    $(".PopupRegisterBanner").on("click", function (e) {

        $(".RegisterInBanner").click();

    });


    $(".RegisterInBanner").on("click", function (e) {

        $(".LoginRegisterContainer").toggle();
        $(".LoginRegisterContainer").closest(".row-fluid, .row").toggle();
        $(".PopupRegisterBannerContainer").toggleClass("Bordered");

        $("li.tb").removeClass("active");

        if (isMobile(true)) {

            $(this).closest("div.RwRegisterLogin").find("div.UyeKayitCol").removeClass("pull-right");

            if ($(".UyeOlModal:visible").length > 0) {

                $("li.tb.reg").addClass("active");

            }
            else {

                $("li.tb.log").addClass("active");

            }

        } else {

            if ($(this).closest("div.RwRegisterLogin").find("div.UyeKayitCol").hasClass("pull-right")) {

                $(this).text($(this).attr("data-cur"));
                $(this).closest("div.RwRegisterLogin").find("div.UyeKayitCol").removeClass("pull-right");

                $("li.tb.reg").addClass("active");


            }
            else {

                $(this).text($(this).attr("data-other"));
                $(this).closest("div.RwRegisterLogin").find("div.UyeKayitCol").addClass("pull-right");

                $("li.tb.log").addClass("active");

            }

        }

        $cur = $(".LoginRegisterContainer");

        $cur.css("opacity", "0.1");

        $cur.animate({
            opacity: 1
        }, 500, function () {
        });


    });


    $(".LogRegTabs li").on("click", function (e) {

        $(".RegisterInBanner").click();

    });


    $("#PayNow").on("click", function (e) {

        document.location.href = $(this).attr("href");

    });
    $(".ModalTab").on("click", function (e) {

        $(".ModalTab").removeClass("active");
        $(this).addClass("active");

        if ($(this).hasClass("Login")) {
            $(".LoginRow").show();
            $(".RegisterRow").hide();
        }
        else {

            $(".LoginRow").hide();
            $(".RegisterRow").show();
        }


    });

    $(".SepetProducts #MinCartClose").live("click", function () {
            location.reload();
    });

    //$("#AccountMenu a.LoginIcon, #AccountMenu a.RegisterIcon").live("click", function (e) {

    //    if ($("#LoginRegisterModal").length > 0) {

    //        $("#LoginRegisterModal").modal("show");

    //        if ($(this).hasClass("RegisterIcon") == true) {
    //            $(".ModalTab.Register").trigger("click");
    //        }
    //        else {
    //            $(".ModalTab.Login").trigger("click");
    //        }

    //        e.preventDefault();
    //        return false;
    //    }

    //});



    if ($("#WelcomeModal").length > 0) {

        $('#WelcomeModal').modal({
            // backdrop: "static"
        });

    }

    $("form.UyeOlModal").live("submit", function () {

        $form = $(this);

        $("#LoginButton").attr("disabled", "disabled");
        $(".AjaxLoader").show();

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                $(".AjaxLoader").hide();
                $("#LoginButton").removeAttr("disabled");

                if (dt.Sonuc == true) {

                    if (UseTagManager) {
                        AddUserAction("SignUp");
                    }

                    if (dt.JsonRs == "Redirect") {

                        if (dt.Deger5.length > 0) {

                            document.location = dt.Deger5;
                        }
                        else {
                            document.location = "/";
                        }
                    }
                    else if (dt.JsonRs == "Redirect") {

                        $form.hide();
                        $(".AjaxLoader").show();
                        $(".RwRegisterLogin").hide();

                        document.location = "/";
                    }

                    if (dt.JsonRs == "Reload") {

                        $form.hide();

                        $(".AjaxLoader").show();
                        $(".RwRegisterLogin").hide();

                        document.location.reload();
                    }

                    $("#AlertResult").removeClass("alert-error");
                    $("#AlertResult").hide();

                    if ($("#register_FbRedirectUrl").length > 0 && $("#register_FbRedirectUrl").val() != "" && $("#register_FbRedirectUrl").val().indexOf("undefined") != -1) {
                        document.location = $("#register_FbRedirectUrl").val();
                    }


                }
                else {

                    $("#AlertResult").removeClass("alert-success");
                    $("#AlertResult").addClass("alert-danger");
                    $("#AlertResult").addClass("alert-error").show().find("span").html(dt.IslemSonucAciklama);
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });

    $("form.UyeGirisModal").live("submit", function () {

        $form = $(this);

        $("#LoginButton").attr("disabled", "disabled");
        $(".AjaxLoader").show();

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                $(".AjaxLoader").hide();
                $("#LoginButton").removeAttr("disabled");

                if (dt.Sonuc == true) {

                    if (UseTagManager) {
                        AddUserAction("Login");
                    }

                    if (dt.JsonRs == "Reload") {

                        $("#AlertResult").removeClass("alert-danger");
                        $("#AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);

                        $(".AjaxLoader").show();
                        $form.hide();
                        $(".RwRegisterLogin").hide();

                        document.location.reload();

                    }


                    if (dt.JsonRs == "Redirect") {

                        $form.hide();
                        $(".AjaxLoader").show();
                        $(".RwRegisterLogin").hide();

                        document.location = dt.Deger5;
                    }

                    $("#AlertResult").removeClass("alert-danger");

                    if ($("#register_FbRedirectUrl").length > 0 && $("#register_FbRedirectUrl").val() != "" && $("#register_FbRedirectUrl").val().indexOf("undefined") != -1) {
                        document.location = $("#register_FbRedirectUrl").val();
                    }


                }
                else {

                    $("#AlertResult").removeClass("alert-success");
                    $("#AlertResult").addClass("alert-danger").show().find("span").html(dt.IslemSonucAciklama);
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });

    //PRODUCTS HOVER 
    $(".ProductList .Prd a").live('click', function (e) {

        if (UseTagManager == true) {

            AddGaEvent('', 'Product List', 'Product Click', $(this).closest(".Prd"));

        }

        //return false;
        //e.preventDefault();


    });

    if (isMobile(false) && isAppleMobile() && !IsAndroid()) {

        $(".ProductList .Prd").live('click', function (e) {

            document.location.href = $(this).find("a:first").attr("href");

        });
    }

    var ScrollContentID = "LastScrollTop" + $("#PID").val();

    if (isMobile(true) == false) {

        $(".ProductList .Prd").live({
            mouseenter:
               function () {

                   $.cookie(ScrollContentID, null, { expires: -1 });
                   $.cookie(ScrollContentID, $(window).scrollTop(), { expires: 0.05 });


                   if (isMobile(false) && isAppleMobile() && !IsAndroid()) {
                       document.location.href = $(this).find("a:first").attr("href");
                   }

                   $nextPrd = $(this).next();
                   $prevPrd = $(this).prev();
                   $curItem = $(this);
                   $row = $curItem.parent();

                   var index = $curItem.index();

                   $topPrd = $(this).closest(".row").prev().find(".Prd:eq(" + index + ")");
                   $bottomPrd = $(this).closest(".row").next().find(".Prd:eq(" + index + ")");

                   if ($(this).find(".img2").length > 0 && $(this).find(".img2").attr("src") != undefined && $(this).find(".img2").attr("src") != "/images/src2.gif" && $(this).find(".img2").attr("src") != "") {

                       $(this).find(".img1").hide();

                       if ($(this).find(".img2").attr("data-src") != undefined && ($(this).find(".img2").attr("src") == undefined || $(this).find(".img2").attr("src").indexOf("404") != -1)) {
                           $(this).find(".img2").attr("src", $(this).find(".img2").attr("data-src"));
                       }

                       $(this).find(".img2").show();

                   }

                   if ($nextPrd.length > 0) {

                       if ($nextPrd.find(".img2").length > 0 && $(this).find(".img2").attr("src") != undefined && $nextPrd.find(".img2").attr("src") != "/images/src2.gif" && $nextPrd.find(".img2").attr("src") != "") {

                           if ($nextPrd.find(".img2").attr("data-src") != undefined && ($nextPrd.find(".img2").attr("src") == undefined || $nextPrd.find(".img2").attr("src").indexOf("404") != -1)) {
                               $nextPrd.find(".img2").attr("src", $nextPrd.find(".img2").attr("data-src"));
                           }


                       }
                   }

                   if ($prevPrd.length > 0) {

                       if ($prevPrd.find(".img2").length > 0 && $prevPrd.find(".img2").attr("src") != "/images/src2.gif" && $prevPrd.find(".img2").attr("src") != "") {

                           if ($prevPrd.find(".img2").attr("data-src") != undefined && ($prevPrd.find(".img2").attr("src") == undefined || $prevPrd.find(".img2").attr("src").indexOf("404") != -1)) {
                               $prevPrd.find(".img2").attr("src", $prevPrd.find(".img2").attr("data-src"));
                           }

                       }

                   }

                   if ($topPrd.length > 0) {

                       if ($topPrd.find(".img2").length > 0 && $topPrd.find(".img2").attr("src") != "/images/src2.gif" && $topPrd.find(".img2").attr("src") != "") {

                           if ($topPrd.find(".img2").attr("data-src") != undefined && ($topPrd.find(".img2").attr("src") == undefined || $topPrd.find(".img2").attr("src").indexOf("404") != -1)) {
                               $topPrd.find(".img2").attr("src", $topPrd.find(".img2").attr("data-src"));
                           }


                       }
                   }

                   if ($bottomPrd.length > 0) {

                       if ($bottomPrd.find(".img2").length > 0 && $bottomPrd.find(".img2").attr("src") != "/images/src2.gif" && $bottomPrd.find(".img2").attr("src") != "") {

                           if ($bottomPrd.find(".img2").attr("data-src") != undefined && ($bottomPrd.find(".img2").attr("src") == undefined || $bottomPrd.find(".img2").attr("src").indexOf("404") != -1)) {
                               $bottomPrd.find(".img2").attr("src", $bottomPrd.find(".img2").attr("data-src"));
                           }

                       }

                   }

               },
            mouseleave:
               function () {

                   if ($(this).find(".img2").length > 0 && $(this).find(".img2").attr("src") != "/images/src2.gif" && $(this).find(".img2").attr("src") != "") {

                       $(this).find(".img2").hide();
                       $(this).find(".img1").show();
                   }

               }
        });

    }

    $('.ProductList .Prd').live("click", function (e) {

        $.cookie(ScrollContentID, null, { expires: -1 });
        $.cookie(ScrollContentID, $(window).scrollTop(), { expires: 0.05 });

    });

    $('.ProductListColorContainer div.ProductListColor').live("click", function () {

        var $currentColor = $(this);

        $(".AjaxLoader").show();

        var productID = $(this).closest(".Prd").find("a:first").attr("data-product");
        var colorID = $(this).attr("data-color");

        var params = "ColorID=" + colorID + "&ProductID=" + productID;

        //URLyi istenilen renkte açılması için değiştir.
        var parentURL = $(this).closest(".Prd").find("a:first").attr("href");
        var saltURL = "";

        $detailLinks = $(this).closest(".Prd").find("a:first, a.GotoDetails");

        //ends with number
        var regex = /(\d+)$/;

        if (parentURL.indexOf("#") > 0) {

            saltURL = parentURL.split("#")[0];
            $detailLinks.attr("href", parentURL.split("#")[0] + "#C=" + $(this).attr("data-color"));


        }

        if (regex.test(parentURL) == true) {

            var splittedUrl = parentURL.split("/");

            var curURL = "";
            for (var i = 0; i < splittedUrl.length - 2; i++) {

                if (splittedUrl[i] != "") {
                    curURL += "/" + splittedUrl[i];
                }
            }

            saltURL = curURL;
        }

        $currentColor.closest(".ProductListColorContainer").find(".ProductListColor").removeClass("active");

        $currentColor.addClass("active");

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetImageOfColors",
            data: params,
            success: function (data) {

                $(".AjaxLoader").hide();

                $currentColor.closest(".Prd").find("a:first img").remove();

                $curHeight = $currentColor.closest(".Prd").find("a:first img").height();

                for (var i = 0; i < 2; i++) {

                    var $imgKucuk = $('<img >');
                    $imgKucuk.attr('src', (data[i].ImgPath + "?width=370").replace("_buyuk", "_detay"));
                    $imgKucuk.height($curHeight);

                    $imgKucuk.addClass("img" + (i + 1) + " PImage");

                    if (i >= 1) {

                        $imgKucuk.addClass("gizli");
                    }

                    $imgKucuk.appendTo($currentColor.closest(".Prd").find("a:first"));

                    if (i == 0 && $(".HomeProducts").length > 0) {

                        $currentColor.closest(".Prd").find("a:first").css("background-image", "url(" + $imgKucuk.attr("src") + ")");
                    }

                    if (i == 0 && data[i].ColorUrl != undefined) {
                        $detailLinks.attr("href", saltURL + data[i].ColorUrl);
                    }



                    if (typeof UseSwStat != 'undefined' && UseSwStat == true) {

                        var swparams = GetSwPageParams();

                        swparams = ChangeSwHashedStringParamValue(swparams, "ActionType", "UrunRenkDegistirme");

                        swparams = ChangeSwHashedStringParamValue(swparams, "ProductID", productID);
                        swparams = ChangeSwHashedStringParamValue(swparams, "ColorID", colorID);

                        AddSwAction(swparams);

                    }

                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });



    });

    if ($(".ContentPgArea").length > 0 && isMobile(true)) {
        $('html, body').animate({ scrollTop: $(".ContentPgArea").offset().top }, 'slow');
    }


    $("form.ForgettenForm").live("submit", function () {

        $form = $("form.ForgettenForm");

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: 'json',
            success: function (dta) {

                if (dta.Sonuc == true) {

                    $(".ForgettenForm p:first").html(dta.IslemSonucAciklama);

                    $("#email").hide();
                    $("#forgottenPassSubmit").hide();

                    $(".ForgettenForm p:first").removeClass("alert-error");
                    $(".ForgettenForm p:first").addClass("alert alert-success");

                }
                else {

                    $(".ForgettenForm p:first").html(dta.IslemSonucAciklama);
                    $(".ForgettenForm p:first").addClass("alert alert-error");
                }



            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });

    $("form.UyeOl").live("submit", function () {

        $form = $(this);

        $("#LoginButton").attr("disabled", "disabled");
        $(".AjaxLoader").show();
        $(".Header1, .Header2").hide();

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                $(".AjaxLoader").hide();
                $("#LoginButton").removeAttr("disabled");


                if (dt.Sonuc == true) {

                    if (dt.JsonRs == "Redirect") {
                        if (dt.Deger5.length > 0) {
                            document.location = dt.Deger5;
                        }
                        else {
                            document.location = "/";
                        }
                    }

                    $("#AlertResult").removeClass("alert-error");
                    $("#AlertResult").hide();

                    //$("#AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);

                    $form.hide();

                    if ($("#register_FbRedirectUrl").length > 0 && $("#register_FbRedirectUrl").val() != "" && $("#register_FbRedirectUrl").val().indexOf("undefined") != -1) {
                        document.location = $("#register_FbRedirectUrl").val();
                    }
                }
                else {

                    $("#AlertResult").removeClass("alert-success");
                    $("#AlertResult").addClass("alert-danger");
                    $("#AlertResult").addClass("alert-error").show().find("span").html(dt.IslemSonucAciklama);
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });


    var utm_source = getQuery(window.location.href).utm_source;
    var utm_campaign = getQuery(window.location.href).utm_campaign;
    var utm_medium = getQuery(window.location.href).utm_medium;

    if ((utm_source != undefined && utm_source.length > 0) || (utm_campaign != undefined && utm_campaign.length > 0) || (utm_medium != undefined && utm_medium.length > 0)) {

        $.ajax({
            url: "/" + $("#SmallLangCode").val() + "/p/User/SetUtmParam",
            data: "utm_source=" + utm_source + "&utm_campaign=" + utm_campaign + "&utm_medium=" + utm_medium,
            type: "POST",
            cache: false
        });

    }


    //if ($.cookie('UserGeoLocationCountry') == undefined) {
    //if ($("#SmallLangCode").val() == "tr" && document.URL.indexOf("localhost") <= 0)
    //{
    //    $.ajax({
    //        url: "/" + $("#SmallLangCode").val() + "/p/Geo/GetGeoLocation",
    //        type: "POST",
    //        cache: false,
    //        success: function (dt) { 

    //            if (dt != "TR") {

    //                var PriceCurrencyID = 5;

    //                if (dt == "GB") {
    //                    PriceCurrencyID = 6;
    //                }

    //                document.location.href = "http://www.oxxoshop.com/en/p/Home/ChangeCurrency?Url=/en&currencyID=" + PriceCurrencyID;
    //            }

    //        }
    //    }); 
    //}

    //if ($("#SmallLangCode").val() == "tr") {

    //    $.ajax({
    //        url: "/" + $("#SmallLangCode").val() + "/p/Geo/GetGeoRedirectUrl",
    //        type: "POST",
    //        cache: false,
    //        success: function (dt) {

    //            if (dt != "" && dt != undefined) {

    //            }

    //        }
    //    });
    //}

    $("#SwitchNewLayout").live("click", function () {

        changeSiteTheme($(this).attr("data-ly"));

    });

    $(".BasketContainer .SepetRow").live("swiperight", function () {

        $(this).find(".RemoveIcon").trigger("click");

    });

    $(".BasketContainer .SepetRow").live("swipeleft", function () {

        $(this).find(".RemoveIcon").trigger("click");

    });

    $("#SingOut").live("click", function (e) {

        if (UseTagManager) {
            AddUserAction("Signout");
        }
        //e.preventDefault();
        //return false;

    });

    if (1 == 2 && $("#homebannerFull1").length > 0 && !isMobile(true)) {
        // console.log("snowfalllll");
        $(document).snowfall('clear');
        $(document).snowfall({ shadow: true, round: true, minSize: 1, maxSize: 5, flakeCount: 200 }); // add shadows

    }


    if ($(window).width() > 1000) {


        $("#LoginRegisterModal .Login").live("click", function (e) {
            $('#LoginRegisterModal .modal-content').css();
        });

        $("#LoginRegisterModal .Register").live("click", function (e) {
            $('#LoginRegisterModal .modal-content').css();
        });

    }

});